import styled from "styled-components";

export const Container = styled.div`
@import url('https://fonts.googleapis.com/css2?family=Lato&family=Oswald:wght@700&family=Passion+One&display=swap');

  font-weight: 400;

  & h1 {
    font-family: "Passion One", sans-serif;
  }

  & p {
    font-family: "Oswald", sans-serif;
  }
`;